.section {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.heading {
  margin: 0;
}

.sub {
  margin: 0;
  color: var(--tuna-content-secondary);
}

.starter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-3);
  border: 1px dashed var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
}

.picker {
  display: inline-flex;
}
